import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CohortsComponent } from './pages/cohorts/cohorts.component';
import { AskAyenRoutingModule } from './ask-ayen-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CohortDetailsComponent } from './pages/cohort-details/cohort-details.component';
import { QuestionsComponent } from './pages/questions/questions.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SpecialtiesListComponent } from './pages/specialties-list/specialties-list.component';
import { SpecialtyFormComponent } from './components/specialty-form/specialty-form.component';
import { QuestionDetailsComponent } from './pages/question-details/question-details.component';
import { AnswersLogComponent } from './components/answers-log/answers-log.component';
import { ChangeLogComponent } from './components/change-log/change-log.component';
import { AddCohortExpertComponent } from './components/add-cohort-expert/add-cohort-expert.component';

@NgModule({
  declarations: [
    DashboardComponent,
    CohortsComponent,
    CohortDetailsComponent,
    QuestionsComponent,
    QuestionDetailsComponent,
    AnswersLogComponent,
    ChangeLogComponent,
    SpecialtiesListComponent,
    SpecialtyFormComponent,
    AddCohortExpertComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AskAyenRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    FormsModule,
    NgSelectModule
  ]
})
export class AskAyenModule {}
